import { FetchPodcastStatusResponse } from 'client/modules/AnchorAPI/fetchPodcastStatus';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { useQuery } from 'react-query';
import { AnchorAPI } from '../../modules/AnchorAPI';

const FETCH_PODCAST_STATUS_QUERY = 'fetchPodcastStatus';

function useFetchPodcastStatus() {
  const {
    state: { userId },
  } = useCurrentUserCtx();

  const { data, status } = useQuery<FetchPodcastStatusResponse>(
    [FETCH_PODCAST_STATUS_QUERY, userId],
    () => AnchorAPI.fetchPodcastStatus({ userId: userId! }),
    { enabled: !!userId }
  );
  const formattedData = {
    ...data,
    podcastStatus: data?.podcastStatus ?? 'noActionTaken',
  };

  return { podcastStatusData: formattedData, status };
}

export { useFetchPodcastStatus, FETCH_PODCAST_STATUS_QUERY };
